<template>
  <div id="Q1" class="sub">
    <div class="wrapper">
      <kg-header :headerType="Number(headerType)" />
      <div id="content">
        <div class="inner_static">
          <div id="register">
            <h1 class="tit1">お問い合わせ</h1>
            <div v-if="errorMessage.text"><label class="error_text">{{ errorMessage.text }}</label></div>
            <div v-if="validateErrorMessages">
              <div v-for="(msg,index) in validateErrorMessages" :key="index"><label class="error_text">{{msg}}</label></div>
            </div>
            <p class="lead_upper type3">
              以下の内容で送信します。
            </p>
            <ul class="lst_confirm">
              <li>
                <div class="item">お問い合わせ内容：</div>
                <p class="cnt">{{this.contactData.typeText}}</p>
              </li>
              <li>
                <div class="item">お問い合わせ件名：</div>
                <p class="cnt">{{this.contactData.title}}</p>
              </li>
              <li>
                <div class="item">お問い合わせ内容：</div>
                <p class="cnt">
                  {{this.contactData.body}}
                </p>
              </li>
              <li>
                <div class="item">お問い合わせ内容：</div>
                <p class="cnt">
                  {{this.contactData.body}}
                </p>
              </li>
              <li>
                <div class="item">氏名：</div>
                <p class="cnt">
                  {{this.contactData.lastName}} {{this.contactData.firstName}}
                </p>
              </li>
              <li>
                <div class="item">氏名（カナ）：</div>
                <p class="cnt">
                  {{this.contactData.lastNameKana}} {{this.contactData.firstNameKana}}
                </p>
              </li>
              <li>
                <div class="item">メールアドレス：</div>
                <p class="cnt">
                  {{this.contactData.email}}
                </p>
              </li>
            </ul>
            <ul class="btn_area">
              <li>
                <a class="btn2" @click="back()">修正する</a>
              </li>
              <li>
                <a class="btn1" @click="send()">OK</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <kg-loading-modal ref="loadingModalRef" />
  </div>
</template>

<script>
import axios from 'axios'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
import {KG_URL, KG_STORAGE_KEY} from '../../constants/App'
import LoadingModal from '../../components/common/LoadingModal'

// kaggul Module
import Header from '../components/common/HomeIconHeader'

export default {
  components: {
    'kg-header': Header,
    'kg-loading-modal': LoadingModal
  },
  props: {
    headerType: {
      type: String,
      default: '0'
    }
  },
  data () {
    return {
      contactData: {
        type: 0,
        typeText: '',
        title: '',
        body: '',
        lastName: '',
        firstName: '',
        lastNameKana: '',
        firstNameKana: '',
        email: ''
      },
      // ダブルサブミット対策
      submitDisable: false,
      /** 共通エラーメッセージ */
      errorMessage: { text: '' },
      /** 項目別エラーメッセージ */
      validateErrorMessages: {}
    }
  },
  methods: {
    init: function () {
      let contactData = App.getLocalStorage(KG_STORAGE_KEY.CONTACT_DATA)
      if (contactData == null || Object.keys(contactData).length <= 0) {
        this.$router.push({
          name: 'KgError'
        })
      }
      this.contactData.type = contactData.type
      this.contactData.typeText = contactData.typeText
      this.contactData.title = contactData.title
      this.contactData.body = contactData.body
      this.contactData.lastName = contactData.lastName
      this.contactData.firstName = contactData.firstName
      this.contactData.lastNameKana = contactData.lastNameKana
      this.contactData.firstNameKana = contactData.firstNameKana
      this.contactData.email = contactData.email
    },
    send: function () {
      if (this.submitDisable) return
      this.submitDisable = true
      this.$refs.loadingModalRef.showModal(true)
      this.errorMessage.text = ''
      this.validateErrorMessages = {}
      // ログイン時の場合とAPIを分ける
      let userInfo = App.getLocalStorage(KG_STORAGE_KEY.USER_INFO)
      let api = Object.keys(userInfo).length > 0 ? '/complete-login' : '/complete'
      axios.post(KG_URL.SUPPORT + api, this.contactData)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.$router.push('/kagull/support/complete/' + this.headerType)
          }
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        }).finally(() => {
          this.submitDisable = false
        })
    },
    back: function () {
      this.$router.push('/kagull/support/input/' + this.headerType)
    },
    handleErrorMessage: function (response) {
      if (!response || !response.data) {
        return
      }
      let modalData = {
        title: 'エラー',
        messages: response.data.errorMessage.split(/\r?\n/g),
        messageType: 'error',
        textAlign: 'left'
      }
      App.showModal(modalData)
    }
  },
  created: function () {
    this.init()
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/pages/ContactConfirm.vue